import '.ah{position:relative;}.ssr-plugin'
import '.n{width:100%;}.ssr-plugin'
import '.hs{min-height:200px;}.ssr-plugin'
import '.d{display:flex;}.ssr-plugin'
import '.e{flex-direction:column;}.ssr-plugin'
import '.ab{justify-content:center;}.ssr-plugin'
import '.ao{align-items:flex-start;}.ssr-plugin'
import '.df{padding:2rem;}.ssr-plugin'
import '.ds{background:var(--palette-white);}.ssr-plugin'
import '.b7{overflow:hidden;}.ssr-plugin'
import '.bi{position:absolute;}.ssr-plugin'
import '.jb{top:50%;}.ssr-plugin'
import '.jc{right:1rem;}.ssr-plugin'
import '.jd{transform:translateY(-50%);}.ssr-plugin'
import '.je{width:120px;}.ssr-plugin'
import '.jf{height:120px;}.ssr-plugin'
import '.jg{z-index:0;}.ssr-plugin'
import '.r{align-items:center;}.ssr-plugin'
import '.iq{z-index:1;}.ssr-plugin'
import '.s{gap:0.5rem;}.ssr-plugin'
import '.jh{max-width:calc(100% - 140px);}.ssr-plugin'
import '.ji{font-size:4rem;}.ssr-plugin'
import '.d7{font-weight:700;}.ssr-plugin'
import '.jj{line-height:100%;}.ssr-plugin'
import '.hj{margin:0px;}.ssr-plugin'
import '.a1{color:var(--brand-secondary);}.ssr-plugin'
import '.a2{font-family:FunnelDisplay;}.ssr-plugin'
import { Style, styled } from 'inlines'
import { Text } from '@app/components/core/typography/Text'
import { Image } from '@app/components/core/image/Image'

export interface StatisticProps {
  number: string
  subtitle: string
  illustration?: string
  style?: Style
}

export const Statistic = ({
  number,
  subtitle,
  illustration,
  style,
}: StatisticProps) => {
  return (
    <styled.div className="ah n hs d e ab ao df ds b7"
      data-testid="statistic"
      style={{
        ...style,
      }}
    >
      {/* Background Illustration - Right Aligned */}
      {illustration && (
        <div className="bi jb jc jd je jf jg d r ab"
        >
          <Image
            src={illustration}
            alt={`${subtitle} illustration`}
            style={{
              width: '100%',
              height: '100%',
              objectFit: 'contain',
            }}
          />
        </div>
      )}

      {/* Content - Left Aligned with higher z-index */}
      <div className="ah iq d e ao s jh"
      >
        <div className="ji d7 jj hj a1 a2"
        >
          {number}
        </div>

        {/* Subtitle */}
        <Text.Medium
          style={{
            color: 'var(--brand-secondary)',
            opacity: 0.8,
            margin: 0,
            lineHeight: '140%',
            fontWeight: '400',
          }}
        >
          {subtitle}
        </Text.Medium>
      </div>
    </styled.div>
  )
}
